import { Cart } from '@peerless/data-access/cart-service/server';
import fetcher from '../client';

export const addToCart = (sku: string): Promise<Cart> => {
  return fetcher.post('/cart/add', { sku });
};
